module.exports = "<th>Дата публикации объявлений</th>\n<td>\n  <div class=\"advanced-browser__item\">\n    <selectpopup\n      items=\"::terms.publish_period\"\n      source=\"source.publish_period.value\"\n      />\n  </div>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/publish_period.html
// module id = 354
// module chunks = 0